import { compose } from 'lodash/fp'
import React from 'react'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'
import withReduxForm from '../withReduxForm'
import Checkbox from './Checkbox'
import withRedux from './withRedux'
import SquareCheckbox from './SquareCheckbox'
import Selected from './Selected'

const CheckboxField: React.ComponentType<ICheckboxProps> = FormElement(Checkbox)
const SquareField: React.ComponentType<ICheckboxProps> = FormElement(
  SquareCheckbox(Selected),
)

const ReduxField: React.ComponentType<ICheckboxProps> = compose(
  withReduxForm,
  withRedux,
)(CheckboxField)

const SquareReduxField: React.ComponentType<ICheckboxProps> = compose(
  withReduxForm,
  withRedux,
)(SquareField)

export default ReduxField
export { CheckboxField, SquareField, SquareReduxField }

export interface ICheckboxProps extends IFormElementProps {
  onClick?: (event: React.SyntheticEvent) => void
  small?: boolean
  checked?: boolean
  size?: number
  onKeyDown?: any
  className?: string
  checkboxWrapperStyle?: any
  afterLabel?: any
  inputRef?: React.RefObject<HTMLInputElement>
}
